<template>
  <article class="card card--author">
    <div class="card__inner">
      <MediaCardImage
        :max-width="600"
        :media="media"
        :card-url="pageLink"
        card-url-title="View the Author's profile on Compass"
        class="media--card"
        fit="contain"
      />
      <div class="card__content">
        <div>
          <BlockLink
            v-if="pageLink"
            label="View the Author's profile on Compass"
            :link="pageLink"
          >
            <h3 class="card__title">
              {{ author.firstname }} {{ author.surname }}
            </h3>
          </BlockLink>
          <h3 v-else class="card__title">
            {{ author.firstname }} {{ author.surname }}
          </h3>
          <h4 class="card__subtitle">{{ author.organisation }}</h4>
          <p v-if="author.biography" class="card__intro">
            {{ trimText(author.biography, 120) }}
          </p>
        </div>
        <div class="card__meta">
          <div class="card__meta__group">
            <div v-if="author?.url?.url" class="link">
              <AuthorMeta :url="author.url.url" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import type { ISbStoryData } from 'storyblok'
import type { ContentTypeAuthorStoryblok } from '~/types/storyblok'
import { trimText } from '#imports'

const props = defineProps<{
  // Note: as this is used on both an author page and in a list/card/article context,
  // the blok prop passed can be either a full author story or just the content
  blok?: ISbStoryData<ContentTypeAuthorStoryblok> | ContentTypeAuthorStoryblok
}>()

const author = computed(() =>
  isAuthorStory(props.blok) ? props.blok.content : props.blok,
)
const pageLink = computed(() =>
  isAuthorStory(props.blok) ? '/' + props.blok?.full_slug : useRoute().path,
)

const media = computed(() => author.value?.photo)
</script>

<style lang="less" scoped>
.card.card--author {
  margin: 0 0 @gutter;
  .card__inner {
    .rounded();

    .card__intro {
      .font-sm();
    }

    .card__subtitle {
      margin-top: 0;
    }
  }
}
</style>
